import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faFacebook, 
  faLinkedin, 
  faTelegram, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';

const SocialShare = ({ url = 'https://ejemplo.com', title = 'Mira este contenido', position='fixed' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const iconTwitter = <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0,0,256,256">
  <g 
    fill="#ffffff" 
    fillRule="nonzero" 
    stroke="none" 
    strokeWidth="1" 
    strokeLinecap="butt" 
    strokeLinejoin="miter" 
    strokeMiterlimit="10" 
    strokeDasharray="" 
    strokeDashoffset="0" 
    fontFamily="none" 
    fontWeight="none" 
    fontSize="none" 
    textAnchor="none" 
    style={{ mixBlendMode: 'normal' }}
  >
    <g transform="scale(8.53333,8.53333)">
      <path d="M26.37,26l-8.795,-12.822l0.015,0.012l7.93,-9.19h-2.65l-6.46,7.48l-5.13,-7.48h-6.95l8.211,11.971l-0.001,-0.001l-8.66,10.03h2.65l7.182,-8.322l5.708,8.322zM10.23,6l12.34,18h-2.1l-12.35,-18z"></path>
    </g>
  </g>
</svg>;

    const handleInstagramClick = (e) => {
        e.preventDefault();
        copyToClipboard();
        alert('El enlace se ha copiado. Pégalo en tu historia o publicación de Instagram.');
        window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
    };

    const handleCopyLink = async (e) => {
        e.preventDefault();
        const copied = await copyToClipboard();
        if (copied) {
            alert('¡Enlace copiado al portapapeles!');
        }
    };
    
    const copyToClipboard = async () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(url);
                return true;
            } catch (err) {
                console.log('Clipboard API falló, usando fallback');
                return false;
            }
        }
        return false;
    };

    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(title + ' ' + url)}`;
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    const twitterLink  = `https://x.com/intent/post?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
    const linkedinLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;

    return (
        <div 
            ref={containerRef}
            style={{
                position: position,
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1001,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row-reverse',
            }}
        >
            <button 
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    border: 'none',
                    borderRadius: '50% 0 0 50%',
                    padding: '16px 20px 16px 16px',
                    cursor: 'pointer',
                    boxShadow: '-2px 2px 12px rgba(0,0,0,0.3)',
                    transition: 'all 0.3s ease',
                }}
            >
                <FontAwesomeIcon 
                    icon={isOpen ? faTimes : faShareAlt} 
                    style={{ 
                        color: 'white', 
                        fontSize: '24px',
                        transition: 'transform 0.3s ease',
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                    }} 
                />
            </button>

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                background: 'white',
                padding: isOpen ? '16px' : '0',
                borderRadius: '12px 0 0 12px',
                boxShadow: isOpen ? '-2px 2px 12px rgba(0,0,0,0.2)' : 'none',
                maxWidth: isOpen ? '80px' : '0',
                overflow: 'hidden',
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                opacity: isOpen ? 1 : 0,
                height: isOpen ? 'auto' : 0,
            }}>
                <a 
                    href={whatsappLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={socialIconStyle('#25D366')}
                >
                    <FontAwesomeIcon icon={faWhatsapp} />
                </a>

                <a 
                    href="https://www.instagram.com/" 
                    onClick={handleInstagramClick}
                    style={socialIconStyle('#E4405F')}
                >
                    <FontAwesomeIcon icon={faInstagram} />
                </a>
                
                <a 
                    href={facebookLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={socialIconStyle('#1877F2')}
                >
                    <FontAwesomeIcon icon={faFacebook} />
                </a>
                
                <a 
                    href={twitterLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={socialIconStyle('#000000ff')}
                >
                    {iconTwitter}
                </a>
                
                <a 
                    href={linkedinLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={socialIconStyle('#0A66C2')}
                >
                    <FontAwesomeIcon icon={faLinkedin} />
                </a>
                
                <a 
                    href={telegramLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={socialIconStyle('#0088cc')}
                >
                    <FontAwesomeIcon icon={faTelegram} />
                </a>
                
                <button 
                    onClick={handleCopyLink} 
                    style={socialIconStyle('#6c757d')}
                >
                    <FontAwesomeIcon icon={faLink} />
                </button>
            </div>
        </div>
    );
};

const socialIconStyle = (bgColor) => ({
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: bgColor,
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
});

export default SocialShare;